import { travelTips } from '../../../mocks/travel-tips';

interface TravelTipsProps {
  selectedCountry: string;
}

export default function TravelTips({ selectedCountry }: TravelTipsProps) {
  const getTips = () => {
    switch (selectedCountry) {
      case 'saudi-arabia':
        return travelTips.saudiArabia;
      case 'turkey':
        return travelTips.turkey;
      case 'uae':
        return travelTips.uae;
      case 'morocco':
        return travelTips.morocco;
      case 'egypt':
        return travelTips.egypt;
      case 'jordan':
        return travelTips.jordan;
      case 'malaysia':
        return travelTips.malaysia;
      case 'indonesia':
        return travelTips.indonesia;
      case 'maldives':
        return travelTips.maldives;
      case 'bosnia':
        return travelTips.bosnia;
      default:
        return travelTips.saudiArabia;
    }
  };

  const tips = getTips();

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 
            className="text-4xl md:text-5xl font-bold text-[#1A1F2E] mb-4"
            style={{ fontFamily: 'Playfair Display, serif' }}
          >
            Essential Travel Tips
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Everything you need to know before you go
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {tips.map((tip, index) => (
            <div
              key={index}
              className="bg-white rounded-xl p-6 shadow-md hover:shadow-xl transition-all duration-300"
            >
              <div className="w-12 h-12 bg-[#C9A961]/10 rounded-full flex items-center justify-center mb-4">
                <i className={`${tip.icon} text-[#C9A961] text-2xl`}></i>
              </div>
              <h3 className="text-xl font-bold text-[#1A1F2E] mb-3">
                {tip.title}
              </h3>
              <p className="text-gray-600 leading-relaxed text-sm">
                {tip.content}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
